export const FILE_SIZE_LIMIT = 25;
export const FILE_EXTENSIONS = /(\.doc|\.docx|\.pdf|\.ppt|\.pptx|\.txt|\.zip|\.png|\.jpg|\.jpeg|\.gif)$/i;
export const ALLOWED_EXTENSIONS = FILE_EXTENSIONS.toString().slice(4, -4).replace(/\|\\/g, '').split('.');
